function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { PureComponent, Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import ListItem from './ListItem';
import { classNamesFor } from '../utils/classNames';
var cx;
/**
 * The List component renders lists of items using sematic markup and removes a lot of
 * the boilerplate when working with basic list elements in jsx.
 *
 * - [MDN docs on ul](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/ul)
 *
 * ## Usage
 *
 * Horizontal list with text items
 * ```jsx
 * <List orientation="h">
 *   {['item 1', 'item 2']}
 * </List>
 * ```
 *
 * Add an icon before each item in the list
 * ```jsx
 * <List iconType="tick">
 *   {['item 1', 'item 2']}
 * </List>
 * ```
 *
 * Or handle things yourself...
 * ```jsx
 * <List>
 *   <>
 *     <Icon type="ps4" />
 *     <span>item 1</span>
 *   </>
 *   <>
 *     <Icon type="psvr" />
 *     <span>item 2</span>
 *   </>
 * </List>
 * ```
 *
 * ## Props
 */

var List = /*#__PURE__*/function (_PureComponent) {
  _inherits(List, _PureComponent);

  var _super = _createSuper(List);

  function List() {
    _classCallCheck(this, List);

    return _super.apply(this, arguments);
  }

  _createClass(List, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          qa = _this$props.qa,
          children = _this$props.children,
          iconType = _this$props.iconType,
          className = _this$props.className,
          iconClassName = _this$props.iconClassName,
          itemClassName = _this$props.itemClassName;

      var _List$getClassName = List.getClassName({
        className: className
      }),
          root = _List$getClassName.root;

      return /*#__PURE__*/React.createElement("ul", {
        "data-qa": qa,
        className: root
      }, Children.toArray(children).map(function (el, i) {
        var itemQa = "".concat(qa, "#listItem").concat(i);
        var isTextNode = typeof el === 'string';

        if (el.type === ListItem) {
          return /*#__PURE__*/cloneElement(el, {
            qa: itemQa,
            className: cx(el.props.className, itemClassName)
          });
        }

        return /*#__PURE__*/React.createElement(ListItem, {
          qa: itemQa,
          key: isTextNode ? el : el.key,
          className: itemClassName,
          iconType: iconType,
          iconClassName: iconClassName
        }, el);
      }));
    }
  }]);

  return List;
}(PureComponent);

cx = classNamesFor(List);
/**
 * Gets the classNames attached to the style hooks for this component.
 * @returns {string} the aliased classNames for List
 */

List.getClassName = function (_ref) {
  var className = _ref.className;
  return {
    root: cx(className, 'psw-p-0', 'psw-m-0', 'psw-list-style-none')
  };
};
/**
 * Defines aliases for classNames used by this component
 */


List.useClassNames = function (classNames) {
  List.classNames = classNames;
};

List.defaultProps = {
  qa: 'list',
  className: '',
  itemClassName: '',
  iconClassName: '',
  iconType: '',
  children: []
};
List.propTypes = {
  /**
   * QA identifier
   */
  qa: PropTypes.string,

  /**
   * Custom class names to use, helpful for applying custom margins and / or padding
   */
  className: PropTypes.string,

  /**
   * Class name to apply to all items
   */
  itemClassName: PropTypes.string,

  /**
   * Icon to apply to all items in the list
   */
  iconType: PropTypes.string,

  /**
   * The class to apply to the icon if present
   */
  iconClassName: PropTypes.string,

  /**
   * The list items to render
   */
  children: PropTypes.arrayOf(PropTypes.node)
};
export default List;